"use client"

import { useLanguage } from "../../context/LanguageContext"
import "./LanguageSwitcher.css"

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage()

  return (
    <div className="language-switcher">
      <button className={`language-btn ${language === "en" ? "active" : ""}`} onClick={() => changeLanguage("en")}>
        EN
      </button>
      <button className={`language-btn ${language === "ar" ? "active" : ""}`} onClick={() => changeLanguage("ar")}>
        عربي
      </button>
    </div>
  )
}

export default LanguageSwitcher
